import { Outlet, NavLink } from 'react-router-dom';
import {
    Space,
} from 'antd';

import './styles.scss';

const links = [
    {
        title: 'حسب الافات',
        path: 'pests-dashboard',
    },
    // {
    //     title: 'حسب المنطقه',
    //     path: 'pests-reports-area',
    // },
    {
        title: 'بلاغات',
        path: 'pests-reports',
    },
];

function LandsManagement() {
    return (
        <div>
            <Space
                direction="vertical"
                size="middle"
                style={{ display: 'flex' }}
            >
                <nav className="Nav">
                    {links.map((entry) => (
                        <NavLink
                            key={entry.path}
                            to={`/pests-management/${entry.path}`}
                            className={({ isActive }) => (isActive ? 'IsActive' : '')}
                        >
                            {entry.title}
                        </NavLink>
                    ))}
                </nav>
                <Outlet />
            </Space>
        </div>
    );
}

export default LandsManagement;
